import { View } from "@react-pdf/renderer";
import { PDFAcordoResponse } from "features/acordo/typings";
import { PDFLayout } from "ui/components/PDF";
import { PDFTable } from "ui/components/PDF";
import SummaryItem from "components/PDF/components/SummaryItem/index";
import { PDFHeaderProps } from "components/PDF/Header";
import { getStatusAcordoText } from "./../../util/getStatusAcordoText";
import useDividasAcordoPdfColumns from "./../../hooks/useDividasAcordoPdfColumns";
import useEntradaAcordoPdfColumns from "./../../hooks/useEntradaAcordoPdfColumns";
import useParcelasAcordoPdfColumns from "./../../hooks/useParcelasAcordoPdfColumns";

function PDFAcordo(props: PDFAcordoResponse) {
  const columnsEntrada = useEntradaAcordoPdfColumns();
  const columnsParcelas = useParcelasAcordoPdfColumns();
  const columnsDividas = useDividasAcordoPdfColumns();

  const cards: PDFHeaderProps["cards"] = [
    {
      title: "Status",
      value: getStatusAcordoText(props.status, props.dataCancelamento),
    },
  ];

  if (props.diasEmAtraso && !props.dataCancelamento) {
    cards.push({
      title: "Dias em atraso",
      value: props.diasEmAtraso.toString(),
    });
  }

  return (
    <PDFLayout
      fontSize={8}
      orientation="portrait"
      includeDocument={true}
      assinaturas={[]}
      headerProps={{
        logo: props?.logo!,
        subTitle: `${props.unidade.numero ?? "--"} ${
          props.unidade.blocoQuadra ? `, ${props.unidade.blocoQuadra}` : ""
        }`,
        tenant: props?.nomeTenant!,
        title: `Detalhamento do Acordo - ${props?.codigo || ""}`,
        cards,
      }}
      footerProps={{
        tenant: props?.nomeTenant!,
        logo: props?.logoAdm!,
        endereco1: props?.endereco1!,
        endereco2: props?.endereco2!,
      }}
    >
      <View style={{ minHeight: "100%" }}>
        <View style={{ marginBottom: 6 }}>
          <SummaryItem title={`Proprietário: ${props.morador.nome}`} bordered />
        </View>

        {props.entrada ? (
          <>
            <View style={{ marginTop: 12 }}>
              <SummaryItem title={`Entrada`} />

              <PDFTable columns={columnsEntrada} data={[props.entrada]} />
            </View>
          </>
        ) : null}

        {props.parcelas?.length ? (
          <>
            <View style={{ marginTop: 12 }}>
              <SummaryItem title={`Parcelas`} />

              <PDFTable columns={columnsParcelas} data={props.parcelas} />
            </View>
          </>
        ) : null}

        {props.dividasAcordo?.length ? (
          <>
            <View style={{ marginTop: 12 }}>
              <SummaryItem title={`Receitas acordadas`} />

              <PDFTable columns={columnsDividas} data={props.dividasAcordo} />
            </View>
          </>
        ) : null}
      </View>
    </PDFLayout>
  );
}

export default PDFAcordo;
